import classNames from "classnames";

import styles from "./Flag.module.scss";

interface FlagProps {
  country?: string;
  // helps to highlight flag on white background
  withBorder?: boolean;
  className?: string;
}

export const Flag = ({className, country, withBorder}: FlagProps) => {
  if (!country) {
    return null;
  }

  return <i className={classNames("fi", `fi-${country}`, className, {[styles.withBorder]: withBorder})} />;
};
